<h1 mat-dialog-title class="p-2 text-center" i18n>Tests disponibles pour cette matrice </h1>
<div mat-dialog-content class="p-3 black" >

    <div class="row">
        <mat-form-field class="col">
            <input matInput [(ngModel)]="BatchCode" i18n-placeholder placeholder="Code Dossier" required>
        </mat-form-field>
        <div class="col-auto">
            <button appPreventDoubleClick class="col me-1 h-75" color="basic" mat-stroked-button (throttledClick)="search()" i18n>
                Chercher
            </button>
        </div>
    </div>
    @if (AvailableTestList.length > 0) {
    <div class="container-fluid overflow-y-only" >
        <div class="row text-center">
            <div class="col fw-bold" i18n>Nom</div>
            <div class="col-2 fw-bold" i18n>Unité </div>
            <div class="col-2 fw-bold" i18n>Unité affichée</div>
            <div class="col-2 fw-bold" i18n>Comparaison LQ</div>
        </div> 
        @for (test of AvailableTestList; track test.Code; let i = $index) {

            <div class="row text-center" [style.background]="i % 2 === 0  ? 'white' : 'orange'">
                <div class="col">
                    {{test.Name}}
                </div>
                <div class="col-2">
                    {{test.ElimsUnitName}}
                </div>
                <div class="col-2">
                    {{test.DisplayedUnitName}}
                </div>
                <div class="col-2">
                    {{getComparaisonLQLabel(test.ComparaisonLQ)}}
                </div>
            </div>
        }
    </div>
    }
    <!-- NEW PRODUCT GROUP -->

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()" i18n>
            Annuler
        </button>
        <button  appPreventDoubleClick class="col ms-1 white" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()" i18n>
            Ajouter
        </button>
    </div>
</div>